import { render } from "./PanelUser.vue?vue&type=template&id=2ac74ab5"
import script from "./PanelUser.vue?vue&type=script&lang=js"
export * from "./PanelUser.vue?vue&type=script&lang=js"

import "./PanelUser.vue?vue&type=style&index=0&id=2ac74ab5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__